import { render, staticRenderFns } from "./Masters2024.vue?vue&type=template&id=d361218e&scoped=true"
import script from "./Masters2024.vue?vue&type=script&lang=js"
export * from "./Masters2024.vue?vue&type=script&lang=js"
import style0 from "./Masters2024.vue?vue&type=style&index=0&id=d361218e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d361218e",
  null
  
)

export default component.exports